import { useContext, useEffect, useMemo, useState } from "react"
import _ from "underscore";
import { dateConvert } from "../../../utils/Helper.js";
import services from "../../../services/services.js";
import { Urls } from "../../../services/Urls.js";
import { ToastContext } from "../../../context/ToastContext.js";
import { callautopopulate } from "../../../services/callautopop.js";
import { useQuestionBank } from "./useQuestionBank.js";

export const useCreateSurvey = ({ options, onClose, editData, gridData }) => {

    const [questions, setQuestions] = useState(null);
    const surveyQuestions = null;
    const { questionList } = useQuestionBank({ questions, setQuestions, surveyQuestions });
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [activeStep, setActiveStep] = useState(1);
    const [fieldValues, setFieldValues] = useState({ start_datetime: new Date(), start_time: new Date(), end_datetime: new Date(), end_time: new Date(), disabled: {}, questions: { questions: {}, category: {} }, created_datetime: "", publish_datetime: "", is_change: false });
    const [formOpts, setFormOpts] = useState({});
    const [loader, setLoader] = useState(false);
    const [opts, setOpts] = useState({});

    useEffect(() => {
        callautopopulate("question_category", "question_type", "rating_symbols").then((res) => {
            setOpts({ category: _.sortBy(res?.question_category, "question_category_name"), types: res?.question_type, symbol: _.sortBy(res?.rating_symbols, "rating_symbol_name"), apiCall: true });
        });
    }, [])

    useEffect(() => {
        setFormOpts((prev) => ({
            ...prev,
            types: options?.types?.map(item => { return { ...item, label: item?.survey_type_name } }),
            survey_templates: options?.survey_templates?.map(item => { return { ...item, label: item?.template_name } })
        }));
    }, [options])

    useEffect(() => {
        if (!_.isEmpty(editData)) {
            handleEdit();
        }
    }, [editData, formOpts])

    const formJson = [
        {
            step: 1,
            label: "Details",
            fields: [
                {
                    label: "Survey Title",
                    name: "survey_name",
                    col: "6",
                    type: "text",
                    required: true,
                    disabled: fieldValues?.disabled?.survey_name || false
                },
                {
                    label: "Survey Type",
                    name: "survey_type",
                    col: "6",
                    type: "select",
                    option: formOpts?.types,
                    required: true,
                    disabled: fieldValues?.disabled?.survey_type || false
                },
                {
                    label: "Welcome Template",
                    name: "welcome_template",
                    col: "6",
                    type: "select",
                    option: formOpts?.survey_templates,
                    required: true,
                    disabled: fieldValues?.disabled?.welcome_template || false
                },
                {
                    label: "Thank You Template",
                    name: "thank_you_template",
                    col: "6",
                    type: "select",
                    option: formOpts?.survey_templates,
                    required: true,
                    disabled: fieldValues?.disabled?.thank_you_template || false
                },
                {
                    label: "Start Date",
                    name: "start_datetime",
                    col: "3",
                    type: "date",
                    required: true,
                    disabled: fieldValues?.disabled?.start_datetime || false
                },
                {
                    label: "Start Time",
                    name: "start_time",
                    col: "3",
                    type: "timepicker",
                    required: true,
                    disabled: fieldValues?.disabled?.start_datetime || false
                },
                {
                    label: "End Date",
                    name: "end_datetime",
                    col: "3",
                    type: "date",
                    required: true,
                    disabled: fieldValues?.disabled?.end_datetime || false
                },
                {
                    label: "End Time",
                    name: "end_time",
                    col: "3",
                    type: "timepicker",
                    required: true,
                    disabled: fieldValues?.disabled?.end_datetime || false
                },
                {
                    label: "Description (Optional)",
                    name: "survey_descr",
                    col: "12",
                    type: "textarea",
                    required: false,
                    disabled: fieldValues?.disabled?.survey_descr || false
                },
            ]
        },
        {
            step: 2,
            label: "Questions",
        },
        {
            step: 3,
            label: "Settings",
            fields: [
                {
                    label: "Secure Survey",
                    key: "is_secure_survey",
                    disabled: editData?.survey_details?.[0]?.is_edit_secure_survey !== undefined ? !editData?.survey_details?.[0]?.is_edit_secure_survey : false
                },
                {
                    label: "Record Respondent's Name",
                    key: "is_record_respondent",
                    disabled: fieldValues?.survey_status === "closed" || fieldValues?.survey_status === "active"
                },
                {
                    label: "Allow marking sections as irrelevant",
                    key: "is_allow_irrelevant",
                    disabled: fieldValues?.survey_status === "closed" || fieldValues?.survey_status === "active"
                },
                {
                    label: "Allow responses to be edited",
                    key: "is_allow_response_edit",
                },
                {
                    label: "Allow Copy/Paste",
                    key: "is_allow_copy_paste"
                },
                {
                    label: "View Section Wise",
                    key: "is_section_view"
                },
            ]
        },
    ]

    const handleChange = (obj, e) => {
        setFieldValues((prev) => ({ ...prev, [obj?.name]: (obj?.name === "start_time" || obj?.name === "end_time") ? e : e.target.value, is_change: true }));
        if (obj?.name === "is_allow_response_edit" && e.target?.value) {
            setFieldValues((prev) => ({ ...prev, number_of_response_edit: 1 }));
        }
    }

    const handleSaveSurvey = async (closePopup, step, previous) => {
        try {
            setLoader(true);
            if (fieldValues?.is_allow_response_edit && fieldValues?.number_of_response_edit < 1) {
                showInfo("Info", "Number of edits allowed should be greater than 0");
                return;
            }
            let questionTvp = [];
            Object.keys(fieldValues?.questions?.questions || {}).forEach(item => {
                const questionData = fieldValues.questions.questions[item];
                if (questionData && Object.keys(questionData).length > 0) {
                    let obj = {
                        question_id: parseInt(item),
                        question_order_number: questionData?.question_order_number || 0,
                        category_order_number: 0
                    };
                    Object.values(fieldValues?.questions?.category || {}).forEach(cate => {
                        if (cate?.all_quest?.includes(parseInt(item))) {
                            obj.category_order_number = cate?.category_order_number || 0;
                        }
                    });

                    questionTvp.push(obj);
                }
            });
            const payload = {
                "survey_id": fieldValues?.survey_id || 0,
                "survey_name": fieldValues?.survey_name?.trim() || "",
                "survey_descr": fieldValues?.survey_descr || "",
                "survey_type_id": fieldValues?.survey_type?.survey_type_id || 0,
                "status_id": !_.isEmpty(editData) ? fieldValues?.status_id : _.findWhere(options?.status, { status_key: "draft" })?.status_id || 0,
                "start_datetime": `${dateConvert(fieldValues?.start_datetime, "iso-string")?.split("T")?.[0]}T${dateConvert(fieldValues?.start_time, "hour-min")}` || "",
                "end_datetime": `${dateConvert(fieldValues?.end_datetime, "iso-string")?.split("T")?.[0]}T${dateConvert(fieldValues?.end_time, "hour-min")}` || "",
                "welcome_template_id": fieldValues?.welcome_template?.template_id || 0,
                "greet_template_id": fieldValues?.thank_you_template?.template_id || 0,
                "is_record_respondent": fieldValues?.is_record_respondent || false,
                "is_allow_irrelevant": fieldValues?.is_allow_irrelevant || false,
                "is_allow_response_edit": fieldValues?.is_allow_response_edit || false,
                "is_allow_copy_paste": fieldValues?.is_allow_copy_paste || false,
                "is_section_view": fieldValues?.is_section_view || false,
                "is_secure_survey": fieldValues?.is_secure_survey || false,
                "number_of_response_edit": fieldValues?.is_allow_response_edit ? parseInt(fieldValues?.number_of_response_edit) : 0,
                "question_orders": questionTvp || []
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTSURVEYINFO"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                if (closePopup) {
                    onClose();
                    setFieldValues((prev) => ({ ...prev, start_datetime: new Date(), start_time: new Date(), end_datetime: new Date(), end_time: new Date(), disabled: {}, questions: {}, created_datetime: "", publish_datetime: "" }));
                }
                setFieldValues((prev) => ({ ...prev, survey_id: res?.body?.data?.survey_id?.[0]?.survey_id, is_change: false }));
                fieldValues?.is_change && setActiveStep(previous ? (activeStep - 1) : (step ? step : (activeStep + 1)));
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const handleEdit = () => {
        let disabled = {};
        const surveyData = editData?.survey_details?.[0];
        const survey_type = _.findWhere(formOpts?.types, { survey_type_id: surveyData?.survey_type_id });
        const welcome_template = _.findWhere(formOpts?.survey_templates, { template_id: surveyData?.welcome_template_id });
        const thank_you_template = _.findWhere(formOpts?.survey_templates, { template_id: surveyData?.greet_template_id });
        if (surveyData?.survey_status !== "draft") {
            disabled["survey_type"] = true;
            disabled["start_datetime"] = true;
            disabled["survey_descr"] = true;
        }
        if (surveyData?.survey_status !== "draft" && surveyData?.survey_status !== "published") {
            disabled["survey_name"] = true;
        }
        if (surveyData?.survey_status === "closed" || surveyData?.survey_status === "active") {
            if (surveyData?.survey_status === "closed") {
                disabled["end_datetime"] = true;
            }
            disabled["welcome_template"] = true;
            disabled["thank_you_template"] = true;
        }
        let questionObj = {};
        let categoryObj = {};
        _.filter(editData?.survey_question_details, item => item?.question_id)?.forEach(item => {
            questionObj[item?.question_id] = {
                question_id: item?.question_id,
                question_order_number: item?.question_order_number || 0,
            }
            categoryObj[item?.question_category_id] = {
                question_category_id: item?.question_category_id,
                category_order_number: item?.category_order_number || 0,
                all_quest: []
            }
        })
        setFieldValues((prev) => ({ ...prev, ...surveyData, questions: { questions: questionObj, category: categoryObj }, survey_type, welcome_template, thank_you_template, disabled, start_time: new Date(surveyData?.start_datetime), end_time: new Date(surveyData?.end_datetime), disabled_questions: !editData?.survey_details?.[0]?.is_question_add ? _.uniq(_.pluck(editData?.survey_question_details, "question_id")) : null }))
    }

    const handleNext = (step, previous) => {
        if (activeStep === step) return;
        if (activeStep === 1 || step > 1) {
            const existing = _.filter(gridData, item => item?.survey_name?.toLowerCase() === fieldValues?.survey_name?.toLowerCase()?.trim());
            if (!fieldValues?.survey_name) {
                showInfo("Info", "Please fill the survey title");
                return;
            } else if (_.isEmpty(fieldValues?.survey_type)) {
                showInfo("Info", "Please select the survey type");
                return;
            } else if (_.isEmpty(fieldValues?.welcome_template)) {
                showInfo("Info", "Please select the welcome template");
                return;
            } else if (_.isEmpty(fieldValues?.thank_you_template)) {
                showInfo("Info", "Please select the thank you template");
                return;
            } else if (!fieldValues?.start_datetime) {
                showInfo("Info", "Please select the survey start date");
                return;
            } else if (!fieldValues?.start_time) {
                showInfo("Info", "Please select the survey start time");
                return;
            } else if (!fieldValues?.end_datetime) {
                showInfo("Info", "Please select the survey end date");
                return;
            } else if (!fieldValues?.end_time) {
                showInfo("Info", "Please select the survey end time");
                return;
            } else if (!_.isEmpty(existing) && existing?.[0]?.survey_id !== (fieldValues?.survey_id || 0)) {
                showInfo("Info", "This survey name already exists");
                return;
            } else if (new Date(`${dateConvert(fieldValues?.start_datetime, "iso-string")?.split("T")?.[0]}T${dateConvert(fieldValues?.start_time, "hour-min")}`) >= new Date(`${dateConvert(fieldValues?.end_datetime, "iso-string")?.split("T")?.[0]}T${dateConvert(fieldValues?.end_time, "hour-min")}`)) {
                showInfo("Info", "Start date & time should be less than end date & time");
                return;
            }
        }
        if ((activeStep === 2 && ((!step && !previous) || (step && step > activeStep))) && _.isEmpty(_.filter(_.uniq(Object?.values(fieldValues?.questions?.questions), "question_id"), item => item?.question_id))) {
            showInfo("Info", "No questions selected");
            step && setActiveStep(2);
            return;
        }
        if (fieldValues?.is_change && !previous && ((step && step > activeStep) || !step)) {
            handleSaveSurvey(false, step, previous);
        } else {
            if (!previous) {
                setActiveStep(step ? step : (activeStep + 1));
            } else {
                setActiveStep(activeStep - 1);
            }
        }
    }

    return useMemo(() => ({
        formJson, activeStep, handleChange, fieldValues, handleSaveSurvey, handleNext, loader, opts, questionList
    }), [formJson, activeStep, handleChange, fieldValues, handleSaveSurvey, handleNext, loader, opts, questionList])
}